import dayjs from 'dayjs';
import useJwt from "@/utils/jwt/useJwt"
// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (
  milisecs,
  toTimeForCurrentDay = true
) => {
  const date = new Date(milisecs);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(date);
};
export const formatChatTime = (milisecs) => {
  var t = new Date(milisecs);
  return dayjs(t).format("h:mm a");
};

export const formatDateToIsToday = (timestamp) => {
  const time = new Date(timestamp);
  const now = new Date();

  const isSameDay =
    time.getFullYear() === now.getFullYear() &&
    time.getMonth() === now.getMonth() &&
    time.getDate() === now.getDate();

  if (isSameDay) {
    const hours = time.getHours() < 10 ? '0' + time.getHours() : '' + time.getHours();
    const minutes = time.getMinutes() < 10 ? '0' + time.getMinutes() : '' + time.getMinutes();
    return `${hours}:${minutes}`;
  }

  const isSameYear = time.getFullYear() === now.getFullYear();

  const day = time.getDate() < 10 ? '0' + time.getDate() : '' + time.getDate();
  const month = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : '' + (time.getMonth() + 1);

  if (isSameYear) {
    return `${day}-${month}`;
  }

  const year = time.getFullYear();
  return `${day}-${month}-${year}`;
}

export const formatChatDate = (milisecs) => {
  const now = new Date();
  const date = new Date(milisecs);

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const targetDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const diffTime = today - targetDay;
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  if (diffDays === 0) {
    return "Today";
  } else if (diffDays === 1) {
    return "Yesterday";
  } else if (diffDays > 1 && diffDays <= 7) {
    return weekdays[date.getDay()];
  } else if (now.getFullYear() === date.getFullYear()) {
    return `${months[date.getMonth()]} ${date.getDate()}`;
  } else {
    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }
};

export const randomString = (len = 50, charSet = "") => {
  charSet =
    charSet || "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomString = "";

  for (let i = 0; i < len; i++) {
    let randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }

  return randomString + nowSecs();
};

export const nowSecs = () => {
  return Math.floor(Date.now());
};

export const isMessageSeen = (message) => {
  const mUserId = Number(useJwt.getUserID())
  if (message.user_id === mUserId) {
    return true;
  }

  if (!message.seens || message.seens.length === 0) {
    return false;
  }

  let seenStatus = false;
  for (let seen of message.seens) {
    if (seen.user_id === mUserId && seen.status === 1) {
      seenStatus = true;
      break;
    }
  }

  return seenStatus;
}

export const isMessageSeenByOther = (message, room) => {
  if (!message || message.id === 0) return false;

  if (!room || !room.room_users || room.room_users.length === 0) return false;
  // console.log(message, room)
  for (let i = 0; i < room.room_users.length; i++) {
    const room_user = room.room_users[i];
    if (room_user.user_id !== Number(useJwt.getUserID())) {
      if (room_user.seen_message_id >= message.id) return true;
    }
  }

  return false;
}

export const getSeenStatus = (message, room) => {

  if (!message.id) {
    return 'Sending... ';
  }

  if (message.created_at !== message.updated_at) {
    return 'Edited, ';
  }

  if (isMessageSeenByOther(message, room)) {
    return 'Seen, ';
  }
  return 'Sent, ';
}

export const isEmpty = (value) => {
  if (!value) {
    return true;
  }
  value = ('' + value).replace(/\r?\n|\r/g, '').replace(' ', '')
  if (value) {
    return false
  }
  return true
}

export const getUserDisplayName = (user) => {
  if (!user) {
    return "Unkown User";
  }

  if (typeof user === 'object') {
    if (!isEmpty(user.full_name)) {
      return user.full_name;
    }
    if (!isEmpty(user.first_name) && !isEmpty(user.last_name)) {
      return user.first_name + ' ' + user.last_name
    }
    if (!isEmpty(user.first_name)) {
      return user.first_name
    }
    if (!isEmpty(user.last_name)) {
      return user.last_name
    }
    if (!isEmpty(user.username)) {
      return user.username
    }
  }

  return "Unkown User";
}

export const getRoomDisplayName = (room) => {
  if (!room || typeof room !== 'object') {
    return "Unknown Room";
  }

  const { group, name, opponents } = room;

  if (group === 1) return name;


  if (!Array.isArray(opponents) || opponents.length === 0) {
    return name || "Unknown Room";
  }

  const currentUserId = Number(useJwt.getUserID());
  const opponent = opponents.find(user => user.id !== currentUserId);

  return opponent ? getUserDisplayName(opponent) : (name || "Unknown Room");
};

const normalizeNumeric = (value) => {
  if (value === undefined || value === null || value === '') return value;

  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? value : numberValue;
};

const normalizeFiles = (files) => {
  if (Array.isArray(files)) return files;
  if (!files) return [];
  return [files];
};

export const normalizeMessage = (message) => {
  if (!message || typeof message !== 'object') return message;

  const normalized = {
    ...message,
    files: normalizeFiles(message.files),
  };

  normalized.id = normalizeNumeric(normalized.id);
  normalized.room_id = normalizeNumeric(normalized.room_id);
  normalized.user_id = normalizeNumeric(normalized.user_id);
  normalized.reply_on = normalizeNumeric(normalized.reply_on);
  normalized.type = normalizeNumeric(normalized.type);
  normalized.created_at = normalizeNumeric(normalized.created_at);
  normalized.updated_at = normalizeNumeric(normalized.updated_at);
  normalized.senderId = normalizeNumeric(normalized.senderId ?? normalized.user_id);

  if (!normalized.username && normalized.user) {
    normalized.username = getUserDisplayName(normalized.user);
  }

  if (normalized.reply_on_message && typeof normalized.reply_on_message === 'object') {
    normalized.reply_on_message = normalizeMessage(normalized.reply_on_message);
  }

  if (normalized.forward_message && typeof normalized.forward_message === 'object') {
    normalized.forward_message = normalizeMessage(normalized.forward_message);
  }

  return normalized;
};

export const normalizeMessages = (messages) => {
  if (!Array.isArray(messages)) return [];
  return messages.map((message) => normalizeMessage(message));
};

export const normalizeRoom = (room) => {
  if (!room || typeof room !== 'object') return room;

  return {
    ...room,
    id: normalizeNumeric(room.id),
    group: normalizeNumeric(room.group),
    unread_count: normalizeNumeric(room.unread_count) || 0,
    last_message: room.last_message ? normalizeMessage(room.last_message) : room.last_message,
  };
};

export const normalizeRooms = (rooms) => {
  if (!Array.isArray(rooms)) return [];
  return rooms.map((room) => normalizeRoom(room));
};

export const getOriginalMessage = (message) => {
  if (!message || !message.forward_message) {
    return normalizeMessage(message);
  }

  let current = message;
  while (current?.forward_message) {
    current = current.forward_message;
  }

  return {
    ...normalizeMessage(current),
    message: parsedMessage(current.message),
  };
}

export const parsedMessage = (messageText) => {

  const hasOrderedList = /\r\d+\./.test(messageText);

  if (!hasOrderedList) return messageText;

  return messageText.replace(/\r(\d+\.)/g, '\n$1');
}

export const getImageWidth = (files) => {

  if (!files.length) return;

  const { width, height } = files[0]

  const ratio = (width / height).toFixed(2)

  if (files.length > 1) {

    const resultHeightMd = 450 / ratio
    const resultHeightXs = 300 / ratio

    return {
      width: { md: 450, xs: 300 },
      height: { md: resultHeightMd, xs: resultHeightXs }
    }
  }

  const breakpoints = {
    xs: 200,
    sm: 300,
    md: 450,
  };

  const result = {};
  const resultHeight = {};
  const maxHeight = (height) => {
    return height > 650 ? 650 : height
  }

  Object.entries(breakpoints).forEach(([key, value]) => {
    result[key] = width < value ? width : value;
    resultHeight[key] = width < value ? maxHeight(width / ratio) : maxHeight(value / ratio);
  });

  return {
    width: result,
    height: resultHeight
  };
};


export function throttle(func, delay = 200, options = { leading: true, trailing: true }) {
  let lastCallTime = 0;
  let timeoutId = null;
  let lastArgs, lastThis;

  const { leading, trailing } = options;

  const invoke = (time) => {
    lastCallTime = time;
    func.apply(lastThis, lastArgs);
    lastArgs = lastThis = null;
  };

  const throttled = (...args) => {
    const now = Date.now();

    if (!lastCallTime && !leading) {
      lastCallTime = now;
    }

    const remaining = delay - (now - lastCallTime);
    lastArgs = args;
    lastThis = this;

    if (remaining <= 0 || remaining > delay) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      invoke(now);
    }
    else if (!timeoutId && trailing) {
      timeoutId = setTimeout(() => {
        invoke(leading ? Date.now() : 0);
        timeoutId = null;
      }, remaining);
    }
  };

  throttled.cancel = () => {
    clearTimeout(timeoutId);
    timeoutId = null;
    lastArgs = lastThis = null;
    lastCallTime = 0;
  };

  return throttled;
}


export const mergeMessages = (
  oldMessages,
  newMessages
) => {

  const map = new Map();

  oldMessages.forEach(msg => {
    map.set(msg.id, msg);
  });

  newMessages.forEach(msg => {

    const old = map.get(msg.id);

    if (
      !old ||
      old.updated_at !== msg.updated_at ||
      old.message !== msg.message ||
      old.status !== msg.status
    ) {

      map.set(msg.id, {
        ...old,
        ...msg,
      });

    }
  });

  return Array
    .from(map.values())
    .sort((a, b) => a.id - b.id);
};

export const openPdf = (link) => {
  if (!link) return;

  const isPdf = /\.pdf($|\?)/i.test(link);

  if (!isPdf) {
    console.warn("This file is not a PDF:", link);
    return;
  }

  window.open(link, "_blank", "noopener,noreferrer");
};
